<template>
  <!-- 模板部分完全不变 -->
  <div class="news-page">
    <!-- 头部组件 -->
    <Headers></Headers>
    <!-- 页面标题 -->
    <div class="news-banner">
      <div class="w">
        <h1 class="banner-title">公司动态与行业资讯</h1>
        <p class="banner-desc">及时掌握公司最新动态与专业行业行情分析</p>
      </div>
    </div>
    <!-- 新闻主内容 -->
    <div class="news-container w">
      <!-- 左侧分类栏 -->
      <div class="news-sidebar">
        <div class="sidebar-title">内容分类</div>
        <ul class="category-list">
          <li
            class="category-item"
            :class="{ active: activeCategory === item.id }"
            v-for="item in categoryList"
            :key="item.id"
            @click="switchCategory(item.id)"
          >
            {{ item.name }}
          </li>
        </ul>
      </div>
      <!-- 右侧内容区 -->
      <div class="news-content">
        <div class="news-list-wrap">
          <!-- 加载状态 -->
          <div
            class="loading-wrap"
            v-if="loading"
            v-loading="loading"
            element-loading-text="正在加载内容..."
            element-loading-spinner="el-icon-loading"
          ></div>
          <!-- 空数据 -->
          <div class="empty-wrap" v-else-if="newsList.length === 0 && !loading">
            <img src="https://picsum.photos/200/150?random=100" alt="空数据" class="empty-img" />
            <p class="empty-text">暂无相关内容数据</p>
          </div>
          <!-- 新闻列表 -->
          <div v-else>
            <div
              class="news-item"
              v-for="(news, index) in newsList"
              :key="news.id"
              @click="viewNewsDetail(news)"
            >
              <div class="news-left">
                <img :src="news.cover || 'https://picsum.photos/200/120?random=default'" alt="封面图" class="news-cover" />
              </div>
              <div class="news-right">
                <h3 class="news-title">{{ news.title }}</h3>
                <p class="news-summary">{{ truncateText(news.summary, 100) }}</p>
                <div class="news-meta">
                  <span class="news-time">{{ formatTime(news.createTime) }}</span>
                  <span class="news-source">{{ news.source || '未知来源' }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <div class="pagination" v-if="total > 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[5, 10, 20]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
            background
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 底部组件 -->
    <Bottom></Bottom>
  </div>
</template>

<script>
import Headers from "../components/headers";
import Bottom from "../components/bottom";
import { Message } from "element-ui";
// 引入你已有的request.js（直接用，不修改）
import request from "../utils/request";
import axios from "axios";
export default {
  name: "CompanyIndustryNews",
  components: { Headers, Bottom },
  data() {
    return {
      categoryList: [
        { id: 0, name: "全部内容" },
        { id: 1, name: "行业资讯" },
        { id: 4, name: "公司动态" }
      ],
      activeCategory: 0,
      newsList: [],
      currentPage: 1,
      pageSize: 5,
      total: 0,
      loading: false,
      // 👉 关键：填写你的后端完整接口URL（替换为实际接口地址）
      newsApiUrl: "https://dy01.txcfgl.net:24081/tx-api/api/v1/article/article-list" 
    };
  },
  methods: {
    // 文本截断（不变）
    truncateText(text, maxLength) {
      if (!text) return "";
      return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    },

    // 格式化时间（不变）
    formatTime(timeStr) {
      if (!timeStr) return "";
      try {
        const date = new Date(timeStr);
        if (isNaN(date.getTime())) return timeStr;
        return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
      } catch (error) {
        return timeStr;
      }
    },

// 修改后的getNewsList方法
async getNewsList() {
      this.loading = true;

        const requestData = {
            status:0,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            category: this.activeCategory === 0 ? "" : this.activeCategory
        };
        
        // 直接使用axios调用，不使用封装的request
        const response = await axios.post(this.newsApiUrl, requestData, {
            timeout: 10000,
            headers: {
                'Content-Type': 'application/json',
            }
        });
        
        // 根据后端实际返回数据结构调整
        // 假设返回格式: { code: 200, data: { records: [], total: 0 }, message: "success" }
        if (response.data && response.data.code === '00000') {
            this.newsList = response.data.data.records || response.data.data.list || response.data.data || [];
            this.total = response.data.data.total || response.data.data.totalCount || 0;

        } else {
            Message.error(response.data.message || "获取数据失败");
            this.newsList = [];
            this.total = 0;
        }
        this.loading = false;
    
},

    // 切换分类（不变）
    switchCategory(id) {
      this.activeCategory = id;
      this.currentPage = 1;
      this.getNewsList();
    },

    // 分页大小改变（不变）
    handleSizeChange(val) {
      this.pageSize = val;
      this.getNewsList();
    },

    // 切换页码（不变）
    handleCurrentChange(val) {
      this.currentPage = val;
      const listWrap = document.querySelector('.news-list-wrap');
      listWrap && listWrap.scrollTo(0, 0);
      this.getNewsList();
    },

    // 跳转到详情页（不变）
    viewNewsDetail(news) {
      if (!news.id) {
        Message.warning("该新闻无有效ID");
        return;
      }
      this.$router.push({
        name: "reading",
        params: { id: news.id }
      });
    }
  },
  mounted() {
    this.getNewsList(); // 页面加载时调用接口
  }
};
</script>

<style lang="less" scoped>
/* 样式部分完全不变 */
.news-page {
  min-height: 100vh;
}

.w {
  width: 1200px;
  margin: 0 auto;
}

.news-banner {
  background-color: #c8171d;
  padding: 40px 0;
  text-align: center;

  .banner-title {
    font-size: 36px;
    color: #fff;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .banner-desc {
    font-size: 18px;
    color: #fff;
    opacity: 0.8;
  }
}

.news-container {
  display: flex;
  margin-top: 30px;
  gap: 30px;
}

.news-sidebar {
  width: 260px;
  background-color: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);

  .sidebar-title {
    font-size: 20px;
    font-weight: bold;
    color: #333;
    padding-bottom: 10px;
    border-bottom: 2px solid #c8171d;
    margin-bottom: 20px;
  }

  .category-list {
    list-style: none;
    padding: 0;
    margin: 0;

    .category-item {
      height: 45px;
      line-height: 45px;
      padding-left: 20px;
      background-color: #f8f8f8;
      margin-bottom: 10px;
      border-radius: 5px;
      cursor: pointer;
      transition: all 0.3s;

      &:hover {
        background-color: #eee;
      }

      &.active {
        background-color: #c8171d;
        color: #fff;
      }
    }
  }
}

.news-content {
  flex: 1;

  .news-list-wrap {
    height: 600px;
    overflow-y: auto;
    padding-right: 10px;
    background-color: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
    margin-bottom: 20px;

    &::-webkit-scrollbar {
      width: 6px;
    }

    &::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 3px;
    }

    &::-webkit-scrollbar-thumb {
      background: #c8171d;
      border-radius: 3px;
    }

    .loading-wrap {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .empty-wrap {
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .empty-img {
        width: 200px;
        height: 150px;
        opacity: 0.5;
        margin-bottom: 20px;
      }

      .empty-text {
        font-size: 16px;
        color: #999;
      }
    }

    .news-item {
      display: flex;
      padding: 20px;
      border-bottom: 1px solid #f5f5f5;
      cursor: pointer;

      &:last-child {
        border-bottom: none;
      }

      &:hover {
        background-color: #fafafa;
      }

      .news-left {
        width: 200px;
        flex-shrink: 0;

        .news-cover {
          width: 100%;
          height: 120px;
          object-fit: cover;
          border-radius: 5px;
        }
      }

      .news-right {
        flex: 1;
        padding-left: 20px;

        .news-title {
          font-size: 20px;
          font-weight: bold;
          color: #333;
          margin-bottom: 10px;
        }

        .news-summary {
          font-size: 14px;
          color: #666;
          line-height: 1.6;
          margin-bottom: 15px;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .news-meta {
          font-size: 12px;
          color: #999;

          .news-time,
          .news-source {
            margin-right: 20px;
          }
        }
      }
    }
  }
}

.pagination {
  text-align: center;
  margin-bottom: 50px;

  :deep(.el-pagination) {
    .el-pager li.active {
      background-color: #c8171d;
      color: #fff;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/news.vue